<ng-container *ngIf="componentConfig as config">
    <serviceos-ng-alert
        class="cancellation-message"
        [type]="'error'"
        *ngIf="view === 'cancel' && cancellationInProgress"
    >
        <div [innerHtml]="config?.screens?.cancel?.cancellation_message"></div>
    </serviceos-ng-alert>
    <ng-container *ngIf="account$ | async">
        <serviceos-ng-card>
            <div class="club-stats" [ngClass]="view" [ngSwitch]="view">
                <ng-container
                    *ngIf="membership$ | async as membership; else purchase"
                >
                    <ng-container *ngSwitchCase="'cancel'">
                        <div
                            class="head"
                            [innerHtml]="config?.screens?.cancel?.title"
                        ></div>
                        <div class="body">
                            <div class="info">
                                <span
                                    class="title"
                                    [innerHtml]="config?.info?.plan_title"
                                ></span>
                                <span class="value">
                                    <span
                                        class="price"
                                        [innerHtml]="config?.info?.plan_price"
                                    ></span>

                                    <span
                                        class="subscription"
                                        [innerHtml]="
                                            config?.info?.plan_subscription_type
                                        "
                                    ></span>
                                </span>
                            </div>
                            <div class="info">
                                <span
                                    class="title"
                                    [innerHtml]="config?.info?.upcoming_billing"
                                ></span>
                                <span class="value">{{
                                    membership.valid_to_formatted
                                }}</span>
                            </div>
                        </div>
                        <div class="footer">
                            <serviceos-ng-button
                                [isFullWidth]="true"
                                [type]="
                                    cancellationInProgress
                                        ? 'primary'
                                        : 'tertiary'
                                "
                                [inactive]="cancellationInProgress"
                                (click)="cancelMembership()"
                                >{{
                                    config?.screens?.cancel?.button
                                }}</serviceos-ng-button
                            >
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'renew'">
                        <div
                            class="head"
                            [innerHtml]="config?.screens?.renew?.title"
                        ></div>
                        <div class="body">
                            <div class="info">
                                <span
                                    class="title"
                                    [innerHtml]="config?.info?.expiration_date"
                                ></span>
                                <span class="value">{{
                                    membership.valid_to_formatted
                                }}</span>
                            </div>
                            <div
                                class="description"
                                [innerHtml]="
                                    config?.screens?.renew?.description
                                "
                            ></div>
                        </div>
                        <div class="footer">
                            <serviceos-ng-button
                                (click)="purchaseMembership()"
                                [isFullWidth]="true"
                            >
                                {{ config?.screens?.renew?.button }}
                            </serviceos-ng-button>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-template #purchase>
                    <ng-container *ngSwitchCase="'purchase'">
                        <div
                            class="head"
                            [innerHtml]="config?.screens?.purchase?.title"
                        ></div>
                        <div class="body">
                            <div class="info">
                                <span
                                    class="title"
                                    [innerHtml]="config?.info?.purchase_total"
                                ></span>
                                <span class="value">
                                    <span
                                        class="price"
                                        [innerHtml]="config?.info?.plan_price"
                                    ></span>
                                    <span
                                        class="subscription"
                                        [innerHtml]="
                                            config?.info?.plan_subscription_type
                                        "
                                    ></span>
                                </span>
                            </div>
                        </div>
                        <div class="footer">
                            <serviceos-ng-button
                                (click)="purchaseMembership()"
                                [isFullWidth]="true"
                            >
                                {{ config?.screens?.purchase?.button }}
                            </serviceos-ng-button>
                            <div
                                class="description"
                                [innerHtml]="
                                    config?.screens?.purchase?.description
                                "
                            ></div>
                        </div>
                    </ng-container>
                </ng-template>
            </div>
        </serviceos-ng-card>
    </ng-container>
</ng-container>
